<template>
  <div>
    <el-form ref="formRef" :model="userForm" label-width="100px">
      <el-form-item label="头像：">
        <el-image style="width: 80px; height: 80px" :src="userForm.headImg.smallHeadImg"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
      </el-form-item>
      <el-form-item label="信息：">
        <div class="item-info">
          <UserInfoList :row="userForm" showList="name,phone,uid,city,birth" :isDialog="true"/>
        </div>
      </el-form-item>
<!--      <el-form-item label="状态：">-->
<!--        <div class="item-info">-->
<!--          <p>信息审核：{{userForm.resumeState == 0 ? "未查看" : userForm.resumeState == 1 ? "待审核" : userForm.resumeState == 2 ? "已通过" : userForm.resumeState == 3 ? "不通过" : "&#45;&#45;"}}</p>-->
<!--          <p>身份证认证：{{userForm.identityAuth.overallAuthState == 0 ? "未提交" : userForm.identityAuth.overallAuthState == 1 ? "待审核" : userForm.identityAuth.overallAuthState == 2 ? "审核通过" : userForm.identityAuth.overallAuthState == 3 ? "审核不通过" : ""}}</p>-->
<!--          <p>微信审核：{{userForm.wechatState == 0 ? '未提交' : userForm.wechatState == 1 ? '待审核' : userForm.wechatState == 2 ? '已通过' : userForm.wechatState == 3 ? '不通过' : '&#45;&#45;'}}</p>-->
<!--          <p>是否是vip：<span style="color: #3a8ee6">{{userForm.vipState == 0 ? '否' : userForm.vipState == 1 ? '是' : userForm.vipState == 2 ? '是' : '&#45;&#45;'}}</span></p>-->
<!--        </div>-->
<!--      </el-form-item>-->
<!--      <el-form-item>-->
<!--        <div class="dialog-footer">-->
<!--          <el-button @click.native="cancel" >取消</el-button>-->
<!--          <el-button type="primary" @click="submit" v-loading="loading">确定</el-button>-->
<!--        </div>-->
<!--      </el-form-item>-->
    </el-form>
    <el-descriptions title="订单信息" border :column="1" style="margin:48px">
      <el-descriptions-item label="商品类型">
        {{userForm.subjectType == -2?'认证费归还':userForm.subjectType == -1?'保证金归还':userForm.subjectType == 1?'认证费':userForm.subjectType == 2?'金币购买':userForm.subjectType == 3?'保证金+认证费':userForm.subjectType == 4?'一伴VIP会员':userForm.subjectType == 5?'保证金+邀请码':userForm.subjectType == 6?'创业者提现':userForm.subjectType == 21?'创业者提现':userForm.subjectType == 22?'提现服务费':userForm.subjectType == 6?'商品':userForm.subjectType == 31?'一伴SVIP会员':userForm.subjectType == 7?'ios银联支付商品':userForm.subjectType == 8?'一对一服务':userForm.subjectType == 9?'脱单圈捐赠':userForm.subjectType == 10?'咖啡券购买':''}}
      </el-descriptions-item>
      <el-descriptions-item label="商品名称">{{userForm.subject}}</el-descriptions-item>
      <el-descriptions-item label="支付金额">{{userForm.payFee}}</el-descriptions-item>
      <el-descriptions-item label="支付类型">
        {{userForm.payType == 1?'支付宝':userForm.payType == 2?'微信':userForm.payType == 3?'苹果':userForm.payType == 4?'华为':userForm.payType == 5?'银联':userForm.payType == 6?'魅族':userForm.payType == 7?'vivo':''}}
      </el-descriptions-item>
      <el-descriptions-item label="支付账号">{{userForm.buyerEmail}}</el-descriptions-item>
      <el-descriptions-item label="收款商户号">{{userForm.sellerEmail}}</el-descriptions-item>
      <el-descriptions-item label="支付时间">{{userForm.createTime}}</el-descriptions-item>
      <el-descriptions-item label="商品价格">{{userForm.totalFee}}</el-descriptions-item>
    </el-descriptions>
  </div>
</template>

<script>

export default {
  name: "SearchBillInfoDialog",
  props: {
    value: Object
  },
  data() {
    return {
      userForm: this.value.userForm,
    }
  },
  methods: {
    cancel() {
      this.$emit("close");
    },

  },
  created() {

  }
}
</script>

<style scoped>
.item-info {
  margin-top: 4px;
}
.item-info p {
  line-height: 24px;
}
</style>
